module.exports = __webpack_public_path__ + "img/delta.043b465a.png";